import * as React from "react";
import { LocalQueryTable } from "../../../../misc/components/queryTable/LocalQueryTable";
import { QueryTableColumn } from "../../../../misc/components/queryTable/QueryTable";
import { IHourSegmentsTableProps } from "./interfaces";
import {
    WaveformType,
    HourBasedSegmentViewModel
} from "../../interfaces/state";
import { JumpToTimePointAction, CloseHourSegmentsModalAction } from "../../actions";

export const HourSegmentsTable = (props: IHourSegmentsTableProps) => {

    const [filteredHourSegments, setFilteredHourSegments] = React.useState<HourBasedSegmentViewModel[]>()
    const [multiDayOffset, setMultiDayOffset] = React.useState<number> ()

    React.useEffect(() => {
        const getfilteredSegments = () => {
            const segmentHoursValue = (props.selectedSegment - 1) * 24
            const segmentSecsStartTime = segmentHoursValue * 60 * 60;
            const segmentEndHoursValue = segmentHoursValue + 23;
            setMultiDayOffset(segmentSecsStartTime);
            const filteredHourSegments = props.hourSegments.filter(x => parseInt(x.RawHour) >= segmentHoursValue && parseInt(x.RawHour) <= segmentEndHoursValue);

            setFilteredHourSegments(filteredHourSegments);
        }

        getfilteredSegments();

    }, [props.selectedSegment]);

    const getWaveformTypeName = (waveformType: WaveformType) => {
        switch (waveformType) {
            case WaveformType.CWFT_RAW:
                return "Raw";
            case WaveformType.CWFT_PROCESSED:
                return "Processed";
            case WaveformType.CWFT_SENSOR_PROCESSED:
                return "Sensor Processed";
            default:
                throw new Error("Unsupported waveform type.");
        }
    }

    const jumpToStart = (row: HourBasedSegmentViewModel) => {
        props.dispatch(JumpToTimePointAction.create(row.StartTime - multiDayOffset));
        props.dispatch(CloseHourSegmentsModalAction.create());
    }

    const renderJumpToStartAction = (row: any) => {
        return (
            <button
                type="button"
                className="btn btn-primary"
                style={{
                    fontSize: "10px",
                    padding: "6px 8px"
                }}
                onClick={() => jumpToStart(row)}
            >
                <i className="fas fa-share" />
            </button>
        );
    }

    const handleOverrideRowMap = (row: HourBasedSegmentViewModel) => {
        return row.Duration <= 0 ? (
            <tr style={{ height: "50px", whiteSpace: "nowrap" }}>
                <td>{row.RawHour}</td>
                <td colSpan={5} style={{ textAlign: "center" }}>
                    NOT IN {waveformType.toUpperCase()}
                </td>
            </tr>
        ) : null;
    }

    const addCoughEvents = (segment: HourBasedSegmentViewModel, selectedWaveform: WaveformType) => {
        if (selectedWaveform === WaveformType.CWFT_RAW) {
            segment.CoughEventCount = props.coughEventTimestamps.filter(
                ts => segment.StartTime <= ts && segment.EndTime > ts
            ).length;
        } else {    // Processed and Sensor Processed waveforms the final sample can have coughs marked
            segment.CoughEventCount = props.coughEventTimestamps.filter(
                ts => segment.StartTime <= ts && segment.EndTime >= ts
            ).length;
        }

        return segment;
    }

    const waveformType = getWaveformTypeName(props.selectedWaveformType);

    return (
        <LocalQueryTable
            collection={filteredHourSegments ? filteredHourSegments.map(hs => addCoughEvents(hs, props.selectedWaveformType)) : []}
            defaultPageSize={8}
            filters={null}
            onFilter={null}
            defaultSort={null}
            rowUniqueIdentifier={row => row.RawHour}
            query={null}
        >
            <QueryTableColumn
                member="RawHour"
                header="Hour (Raw)"
                sortable={true}
                map={(row: HourBasedSegmentViewModel) => row.RawHour}
                overrideRowMap={handleOverrideRowMap}
            />
            <QueryTableColumn
                isHidden={waveformType === "Raw"}
                member="StartTime"
                header={`Start (${waveformType})`}
                sortable={true}
                map={(row: HourBasedSegmentViewModel) => row.StartTimeFormatted()}
            />
            <QueryTableColumn
                isHidden={waveformType === "Raw"}
                member="EndTime"
                header={`End (${waveformType})`}
                sortable={true}
                map={(row: HourBasedSegmentViewModel) => row.EndTimeFormatted()}
            />
            <QueryTableColumn
                isHidden={waveformType === "Raw"}
                member="Duration"
                header={`Length (${waveformType})`}
                sortable={true}
                map={(row: HourBasedSegmentViewModel) => row.DurationFormatted()}
            />
            <QueryTableColumn
                member="CoughEventCount"
                header="Cough Event Count"
                map={row => row.CoughEventCount}
                sortable={true}
            />
            <QueryTableColumn
                member="JumpToStartAction"
                header="Jump To Start"
                map={renderJumpToStartAction}
            />
        </LocalQueryTable>
    );
}
